import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomePageComponent } from './home-page/home-page.component';
import {HomePageFinishComponent} from './home-page-finish/home-page-finish.component';
import { HomePageTeacherComponent } from './home-page-teacher/home-page-teacher.component';
import { HomePageParentComponent } from './home-page-parent/home-page-parent.component';
import { HomePageStudentComponent } from './home-page-student/home-page-student.component';



const routes: Routes = [
    { path: 'old', component: HomePageComponent },
    { path: 'teacher', component: HomePageTeacherComponent },
    { path: 'parent', component: HomePageParentComponent },
    { path: 'student', component: HomePageStudentComponent },
    { path: '', component: HomePageFinishComponent },
    { path: '', redirectTo: '', pathMatch: 'full' },
    { path: '**', redirectTo: '' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: false, scrollPositionRestoration: 'enabled' })],
    exports: [RouterModule]
})
export class AppRoutingModule {}
